// extracted by mini-css-extract-plugin
module.exports = {"cb":"checkbox-input-control-component_cb__3kGnD"};